<template>
    <div>
        <vue-custom-scrollbar class="header-wrapper">
        </vue-custom-scrollbar>
        <vue-custom-scrollbar class="dashboard-content">
            <b-container>
                <b-row class="mt-3 justify-content-md-center">
                    <b-col cols="12" class="c-box schedule-box p-0">
                        <div class="heading mb-3">Pre-camp Messages</div>
                        <b-row>
                            <b-col lg="4" md="6" sm="12" class="message-wrapper mb-4" v-for="(message, index) in messages" :key="index">
                                <div class="message-box">
                                    <a :href="message.url" target="_" class="title">
                                        <div class="mb-4"><span class="fe-play"></span> {{message.title}}</div>
                                    </a>

                                    <div class="time"><span class="fe-clock"></span>{{message.messageLength}}</div>
                                    <a :href="message.downloadLink">
                                        <div class="download"><span class="fe-download"></span></div>
                                    </a>
                                </div>
                            </b-col>
                    
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import vueCustomScrollbar from 'vue-custom-scrollbar';

    export default {
        components: {
            vueCustomScrollbar
        },
        data(){
            return {
                messages: []
            }
        },
        methods: {
            getMessages(){
                this.$http.get('get-precamp')
                .then(res => {
                    this.messages = res.body.precamp
                    console.log(this.messages)
                })
                .catch(err => {
                    console.log(err)
                })
            }
        },
        created(){
            this.getMessages()
        }
    }
</script>

<style lang="scss" scoped>
    .header-wrapper{
        padding: 20px;
        text-align: center;
        font-size: 20px;
        color: #182c8f; 
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
        h1{
            margin-bottom: 0;        
        }
    }

    .message-box{
        width: 100%;
        padding: 20px;
        background-color: rgb(241, 241, 241);
        display: inline-block;
        border-radius: 3px;
        color: #182c8f; 
        vertical-align: top;
        font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif ;
        a:hover{
            text-decoration: none;
        }
        .title{
            margin-bottom: 20px;
            color: #22379e; 
            font-weight: normal;
            transition: all .2s ease-in-out;
            &:hover{
                font-weight: bold;
            }
        }

        .time{
            color: orangered;
            display: inline;
            font-size: 14px;
        }

        .download{
            float: right;
            font-size: 14px;
            color: orangered;
            cursor: pointer;
        }
    }
</style>